/*
 * @Author: Bai.Zhiming
 * @Date: 2020-12-04 18:38:44
 * @LastEditTime: 2021-03-25 20:09:27
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\MC\message\messageReceivingConfig\messageReceivingConfig.js
 * @Description: 消息接收配置管理
 */

angular.module('messageReceivingConfigModule', [])
    . controller('messageReceivingConfigCtrl', ['$scope', 'trsHttpService', '$q', 'modalDialog', 'permissionService', 'jsonArrayToStringService', 'messagePublishService', 'publicToolService',
        function($scope, trsHttpService, $q, modalDialog, permissionService, jsonArrayToStringService, messagePublishService, publicToolService) {

            initStatus();
            isAdministrator();
            getData();

            /**
             * [initStatus description] 状态初始化
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.status = {
                    configid: '',
                    istenantadmin: false, // 是否是租户管理员
                    admin: false, // 是否是超级管理员
                    teamwork: [], // 工作协同提醒 (1为勾选，0为未勾选）
                    notice: [], // 业务公告
                    publicmessage: [], // 公告提醒
                    systemmessage: [], // 系统自动类提醒
                    othermessage: [], // 其他提醒
                    resource: [], // 资源更新提醒
                    tenant: [], // 管理员类提醒
                    teamworkSelectFlag: false, // 工作协同事项提醒 是否是全选
                    sysSelectFlag: false, // 系统提醒 是否是全选
                };
                publicToolService.getModeconfiguration('optionShield', 'messageCenter').then((config) => {
                    $scope.status.optionShild = config;
                });
            }

            /**
             * [getData description] 获取数据
             * @return  {[type]}  [return description]
             */
            function getData() {
                var defer = $q.defer();
                let params = {
                    serviceid: 'messageConfig',
                    method: 'messageConfig',
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, 'GET').then(function(data) {
                    $scope.status.configid = data.data.configid;
                    $scope.status.teamwork = turnObj(data.data.teamwork);
                    $scope.status.notice = turnObj(data.data.notice);
                    $scope.status.publicmessage = turnObj(data.data.publicmessage);
                    $scope.status.systemmessage = turnObj(data.data.systemmessage);
                    $scope.status.othermessage = turnObj(data.data.othermessage);
                    $scope.status.resource = turnObj(data.data.resource);
                    $scope.status.tenant = turnObj(data.data.tenant);

                    checkTeamSelectAll();
                    checkSysSelectAll();

                    defer.resolve();
                });
                return defer.promise;
            }

            /**
             * [turnObj description] arr 转换函数
             * @return  {[type]}  [return description]
             */
            function turnObj(string) {
                let arr = [];
                if (!string) {return arr;}
                var obj = JSON.parse(string);
                for (var key in obj) {
                    var R_obj = {};
                    R_obj.name = key;
                    R_obj.value = obj[key];
                    arr.push(R_obj);
                }
                return arr;
            }

            /**
             * [turnStr description] 转换函数
             * @param   {[type]}  arr  [arr description]
             * @return  {[type]}       [return description]
             */
            function turnStr(arr) {
                let string = '';
                let OBJ = {};
                arr.forEach((item) => {
                    var keyName = item.name;
                    var value = item.value;
                    var obj = {};
                    obj[keyName] = value;
                    Object.assign(OBJ, obj);
                });
                string = JSON.stringify(OBJ);
                return string;
            }

            /**
             * [selectChangeFn description]
             * @param   {[type]}  items  [items description]
             * @param   {[type]}  value  [value description]
             * @return  {[type]}         [return description]
             */
            function selectChangeFn(items, value) {
                items.forEach((item) => {
                    item.value = value;
                });
            }

            /**
             * [teamWorkSelectAll description] 工作协同事项提醒 全选
             * @return  {[type]}  [return description]
             */
            $scope.teamWorkSelectAll = function() {
                if ($scope.status.teamworkSelectFlag) {
                    selectChangeFn($scope.status.teamwork, 0);
                    $scope.status.teamworkSelectFlag = false;
                } else {
                    selectChangeFn($scope.status.teamwork, 1);
                    $scope.status.teamworkSelectFlag = true;
                }
            };

            /**
             * [selectTeam description] 工作协同事项提醒 单选
             * @param   {[type]}  arr   [arr description]
             * @param   {[type]}  item  [item description]
             * @return  {[type]}        [return description]
             */
            $scope.selectTeam = function(arr, item) {
                arr.forEach((key) => {
                    if (key.name == item.name) {
                        key.value = item.value == 1 ? 0 : 1;
                    }
                });
                checkTeamSelectAll();
                checkSysSelectAll();
            };

            /**
             * [checkTeamSelectAll description] 检查工作协同事项提醒  是否是全选
             * @return  {[type]}  [return description]
             */
            function checkTeamSelectAll() {
                var checkTeam = $scope.status.teamwork.find((item) => item.value == 0);
                $scope.status.teamworkSelectFlag = checkTeam == undefined;
            }

            /**
             * [resourceChange description] 资源更新提醒配置
             * @param   {[type]}  item  [item description]
             * @return  {[type]}        [return description]
             */
            $scope.resourceChange = function(item) {
                var value = item.value == 1 ? 0 : 1;
                $scope.status.resource.forEach((key) => {
                    if (key.name == item.name) {
                        key.value = value;
                    }
                });
            };

            /**
             * [sysSelectAll description] 系统提醒 全选
             * @return  {[type]}  [return description]
             */
            $scope.sysSelectAll = function() {
                if ($scope.status.sysSelectFlag) {
                // 这两个是都有的类 all
                    selectChangeFn($scope.status.systemmessage, 0);
                    selectChangeFn($scope.status.othermessage, 0);
                    $scope.status.sysSelectFlag = false;
                } else {
                // 这两个是都有的类 all
                    selectChangeFn($scope.status.systemmessage, 1);
                    selectChangeFn($scope.status.othermessage, 1);
                    $scope.status.sysSelectFlag = true;
                }
            };

            /**
             * [checkSysSelectAll description] 检查系统提醒  是否是全选
             * @return  {[type]}  [return description]
             */
            function checkSysSelectAll() {
            // 这两个是都有的类 all
                var checkSys = $scope.status.systemmessage.find((item) => item.value == 0);
                var checkOther = $scope.status.othermessage.find((item) => item.value == 0);
                $scope.status.sysSelectFlag = !!((checkSys == undefined && checkOther == undefined));
            }

            /**
            * [submitChange description] 保存
            * @return  {[type]}  [return description]
            */
            $scope.submitChange = function() {
                var defer = $q.defer();
                let params = {
                    serviceid: 'messageConfig',
                    method: 'updateMessageConfig',
                    configid: $scope.status.configid,
                    teamWork: $scope.status.teamwork.length > 0 ? encodeURI(turnStr($scope.status.teamwork)) : '',
                    systemmessage: $scope.status.systemmessage.length > 0 ? encodeURI(turnStr($scope.status.systemmessage)) : '',
                    othermessage: $scope.status.othermessage.length > 0 ? encodeURI(turnStr($scope.status.othermessage)) : '',
                    resource: $scope.status.resource.length > 0 ? encodeURI(turnStr($scope.status.resource)) : '',
                };
                params = jsonArrayToStringService.jsonArrayToString(params);
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, 'POST').then(function(data) {
                    modalDialog.alertType('设置成功', '', 'success', false);
                    getData();
                    defer.resolve();
                });
                return defer.promise;
            };

            /**
             * [isAdministrator description] 判断当前用户身份
             * @return  {[type]}  [return description]
             */
            function isAdministrator() {
            // 当前用户是否是系统管理员
                permissionService.isAdministrator().then(function(data) {
                    $scope.status.admin = data;
                });
                // 当前用户是否是租户管理员
                permissionService.isTenantAdministrator().then(function(res) {
                    $scope.status.istenantadmin = res;
                });
            }

            /**
             * [cancel description]  取消
             * @return  {[type]}  [return description]
          */
            $scope.cancel = function() {
                getData();
            };

        }
    ]);
